exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-col[data-v-56a7b63c]{position:relative;display:flex;flex-direction:column;justify-content:space-around;text-align:left;padding:0 20px;height:100%}p[data-v-56a7b63c]{line-height:20px;font-size:14px}p.title[data-v-56a7b63c]{font-size:16px;line-height:20px}p.excerpt[data-v-56a7b63c]{line-height:24px}p .date[data-v-56a7b63c]{font-size:12px}.view-more[data-v-56a7b63c]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56a7b63c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/SlideNews.vue
// module id = 284
// module chunks = 0